<template>
  <div>
    <div class="row mb-2">
      <div class="col-md-12 text-right">
        <b-button v-b-modal.modal-1>Create</b-button>
        <b-modal id="modal-1" title="Plot Alignment">
          <form  @submit.prevent="submitForm">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">Project</label>
                  <select
                    class="form-control"
                    v-model="form._project_id"
                    @change="projectChanges"
                  >
                    <option value="">Select Project</option>
                    <option
                      :value="project._id"
                      v-for="(project, index) in projects"
                      :key="index"
                    >
                      {{ project.name }} ({{ project.code }})
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="">Zone</label>
                  <select
                    class="form-control"
                    v-model="form._zone_id"
                    @change="zoneChanges"
                    multiple
                  >
                    <option
                      :value="zone._id"
                      v-for="(zone, index) in zones"
                      :key="index"
                    >
                      {{ zone.code }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="">Plots</label>
                  <select
                    class="form-control"
                    v-model="form._plot_id"
                    @change="plotChange"
                    multiple
                    required
                  >
                    <option
                      :value="plot.id"
                      v-for="(plot, index) in plots"
                      :key="index"
                    >{{ plot.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            
          </form>
          <template #modal-footer="{ ok, close }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button
              size="sm"
              variant="success"
              @click="submitForm()"
              :disabled="isDisable"
            >
              Register 
            </b-button>
            <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
          </template>
        </b-modal>
      </div>
    </div>
   
    <b-table
      v-if="plots_aligned.length >= 0"
      id="my-table"
      class="dataTable rounded-left"
      :outlined="true"
      :items="plots_aligned"
      :fields="fields"
      head-variant="none"
      table-variant="none"
      :caption-top="true"
    >
      <template #table-caption>Plots Aligned</template>
      <template #cell(#)="data">{{ data.index + 1 }}</template>
      <template #cell(actions)="row">
        <b-dropdown
          id="dropdown-2"
          text="Dropdown Button"
          class="m-md-2"
          size="sm"
          variant="success"
          no-caret
        >
          <template #button-content>
            <b-icon icon="three-dots-vertical" aria-hidden="true"></b-icon>
          </template>
          <b-dropdown-item-button @click="dissassociatePlot(row.item)">
            Delete
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fields: [
        "#",
        {
          key: "_project_id.name",
          label: "Project",
        },
        {
          key: "_zone_id.code",
          label: "Zone",
        },
        {
          key: "_plot_id.code",
          label: "Plot",
        },
        {
          key: "_plot_id.area",
          label: "Area(acrs)",
        },
        'actions',
      ],
      projects: [],
      zones: [],
      plots: [],
      assets: [],
      plots_aligned:[],
      
      form: {
        _user_id: "",
        _project_id: "",
        _zone_id: [],
        _plot_id: []
      },
      isDisable: false
    };
  },
  props: ["customerPlotDetails"],
  mounted() {
    this.getProjects();
    this.getOperationTeamPlot();
  },
  methods: {
    dissassociatePlot(data) {
      let prompt = confirm('Are you sure want to delete ? ');
      if (prompt) {
      // /user/:user_id/disassociate/:plot_id
      let user_id = this.$route.params.id;
      console.log(data);
        window.axios.post('/user/'+user_id+'/disassociate/' + data._plot_id._id).then((resp) => {
          if (resp.data.success) {
            this.$emit('refreshPlots', true);
            alert(resp.data.message);
            location.reload();
          }
        });
      }
    },
    getOperationTeamPlot(){
      console.log("LOAD the alignment")
      let _user_id = this.$route.params.id;
      window.axios.get('/operation-team/plot-alignments',{
        params:{
          _user_id: _user_id
        }
      }).then(resp => {
        let data = resp.data.data;
        this.plots_aligned = data;
      })
    },
    getProjects() {
      window.axios.get("project").then((resp) => {
        console.log(resp.data);
        this.projects = resp.data.data;
      });
    },
    projectChanges() {
      window.axios
        .get("/project-zones/" + this.form._project_id)
        .then((resp) => {
          console.log(resp);
          this.zones = resp.data.data;
        });
      // get the project resort details
      window.axios
        .get("/project-resort-details/" + this.form._project_id)
        .then((resp) => {
          console.log(resp);
          this.credits = resp.data.data.credits;
        });
    },
    zoneChanges() {
      this.plots = [];
      window.axios
        .get("/plots-based-on-zones", {
          params: {
            zones: this.form._zone_id,
          },
        })
        .then((resp) => {
          this.plots = resp.data.data;
        });
    },
    plotChange() {
      this.plots.filter((plot) => {
        if (plot._id == this.form._plot_id) {
          this.form.credits = this.calculateCreditAccordingToArea(plot.area);
          return plot;
        }
      });
    },
    submitForm(){
        this.form._user_id =  this.$route.params.id;
        if(this.form._plot_id.length == 0){
          alert("Please select atleast one plot");
          return;
        }
        window.axios.post('/operation-team/plot-alignments',this.form)
        .then(resp => {
          console.log(resp);
          if(resp.data.success){
            alert(resp.data.message);
            location.reload();
          }
        })
    }
   
  },
  computed: {},
};
</script>

<style scoped>
/deep/ .dataTable {
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable thead {
  background-color: #e6e6e6;
  height: 51px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: "Poppins", sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
}

/deep/ .dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable tr td {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}

/deep/ .dataTable caption {
  border-radius: 10px 10px 0 0;
  height: 64px;
  width: 100%;
  background-color: #dcffd9;
  color: #000;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  letter-spacing: 3.5%;
  padding-left: 27px;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 25px;
}
</style>
